import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { calculateTotalWithInterest } from '../../shared/utils/installment.util';

export enum InterestPercentageEnum {
  _5X = 8.5,
  _6X = 8.5,
  _7X = 9.5,
  _8X = 10.5,
  _9X = 11.5,
  _10X = 12.5,
  _11X = 12.5,
  _12X = 14.5,
}
@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor() {}

  getInstallments(value: any) {
    const installmentsValue = [];
    const installments = this.getTotalInstallments(value, false);

    for (let index = 1; index <= installments; index++) {
      if (index <= 4) {
        installmentsValue.push(value / index);
      } else {
        const valueTotalWithInterest: number = this.getInterest(index, value);
        installmentsValue.push(valueTotalWithInterest / index);
      }
    }
    return installmentsValue;
  }

  getInterest(installment: number, value: number): number {
    const { totalWithInterest } = calculateTotalWithInterest(
      value,
      installment
    );
    return totalWithInterest;
  }

  getTotalInstallments(value: number, free: boolean) {
    let installment =
      value / environment.minimumInstallment < 1
        ? 1
        : value / environment.minimumInstallment;
    if (free) {
      installment = installment > 4 ? 4 : installment;
    } else {
      installment = installment > 12 ? 12 : installment;
    }
    return Math.floor(installment);
  }
}
